import { Validator } from '@vista-digital/validator';
import { cssColourValidator } from '../validators/css-colour';
export const defaultHeroAttributeColours = {};
export const heroAttributeColoursValidator = Validator.objectOf(cssColourValidator);
//# sourceMappingURL=hero-attribute-colours.js.map